module.exports = __webpack_public_path__ + "assets/devices/GSD-442-PG2-0519b0fa9d64c260356dc1fe52ea01b0.svg";